import { Button } from '@/components/ui/button'
import * as Dialog from '@radix-ui/react-dialog'
import { X } from '@/components/icons'

interface ConfirmDialogProps {
  open: boolean
  onClose: () => void
  onConfirm: () => void
  title: string
  description?: string
  confirmLabel?: string
  cancelLabel?: string
  destructive?: boolean
  loading?: boolean
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  description,
  confirmLabel = '확인',
  cancelLabel = '취소',
  destructive = false,
  loading = false,
}: ConfirmDialogProps) {
  return (
    <Dialog.Root
      open={open}
      onOpenChange={(next) => {
        if (!next && !loading) onClose()
      }}
    >
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-[600] bg-black/60 data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-[601] flex w-[92vw] max-w-sm -translate-x-1/2 -translate-y-1/2 flex-col overflow-hidden rounded-2xl bg-surface shadow-xl outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 dark:bg-gray-950">
          <div className="flex items-start justify-between gap-3 border-b border-border-subtle px-5 py-4 dark:border-gray-800">
            <Dialog.Title className="dialog-title font-bold text-text dark:text-gray-100">
              {title}
            </Dialog.Title>
            <Dialog.Close
              className="rounded-md p-1 text-text-subtle hover:bg-surface-muted hover:text-text disabled:opacity-50 dark:hover:bg-gray-800 dark:hover:text-gray-200"
              aria-label="닫기"
              disabled={loading}
            >
              <X className="h-4 w-4" />
            </Dialog.Close>
          </div>

          {description && (
            <div className="px-5 py-4">
              <Dialog.Description className="text-sm text-text-muted dark:text-gray-400">
                {description}
              </Dialog.Description>
            </div>
          )}

          <div className="flex items-center justify-end gap-2 border-t border-border-subtle px-5 py-3 dark:border-gray-800">
            <Button variant="outline" onClick={onClose} disabled={loading}>
              {cancelLabel}
            </Button>
            <Button
              variant={destructive ? 'danger' : 'primary'}
              onClick={onConfirm}
              disabled={loading}
            >
              {loading ? '처리 중...' : confirmLabel}
            </Button>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
